import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { Organizations } from '@app/interface/organizations';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

export interface TicketMailDialogData {
  organization: Organizations;
}

@Component({
  selector: 'izy-write-at-info-at-izysrl',
  imports: [
    CommonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
  ],
  templateUrl: './write-at-info-at-izysrl.component.html',
  styleUrl: './write-at-info-at-izysrl.component.scss',
})
export class WriteAtInfoAtIzysrlComponent {
  assistanceForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<WriteAtInfoAtIzysrlComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TicketMailDialogData,
  ) {
    this.assistanceForm = new FormGroup({
      invoicing_email: new FormControl(''),
    });
  }

  // mailAddress: string = 'info@izysrl.it';
  invoicingEmail: string = 'info@izysrl.it';

  text: string =
    'Per modificare i dati della tua azienda, invia la tua richiesta a:';

  ngOnInit(): void {
    // Initialize form with current organization invoice_mail data
    if (this.data.organization) {
      this.invoicingEmail = this.data.organization.invoicing_email;

      this.assistanceForm.patchValue({
        invoicing_email: this.data.organization.invoicing_email,
      });
    }
  }

  copyToClipboard(): void {
    navigator.clipboard
      .writeText(this.invoicingEmail)
      .then(() => {
        // You could show a small confirmation here or rely on the parent
        this.dialogRef.close(true); // Close with success
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
        this.dialogRef.close(false); // Close with failure
      });
  }

  copyAndRedirect() {
    this.copyToClipboard();
    window.open('https://www.beizy.it/prezzi-beizy', '_blank');
    // or window.location.href = 'https://your-external-link.com';
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
